import { lazy } from 'react'

export const PaymentVariant1 = lazy(() => import('./PaymentVariant1'))
